import BasicIcon from "components/basic-icon/BasicIcon";
import { ModalHeaderProps } from "modals/header/types";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import "./ModalHeader.css";

const mapStateToProps = (state:AppState):ModalHeaderProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
	};
};

class ModalHeader extends Component<ModalHeaderProps.Component> {
	render():JSX.Element{
		let iconElement:JSX.Element|null = null;
		if(this.props.icon){ iconElement = <BasicIcon icon={this.props.icon} />; }

		return (
			<div className="modal-header">
				{iconElement}<h2>{t.t(this.props.text)}</h2>{iconElement}
			</div>
		);
	}
}
export default connect(mapStateToProps)(ModalHeader);
